import { Route } from '@/Enums/Routes/Route.enum';
import ChevronRightIcon from '@/components/Icons/ChevronRightIcon';
import HomeBreadCrumbsIcon from '@/components/Icons/HomeBreadCrumbsIcon';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const CreateCampaignBreadcrumbs = ({ isNew, readOnly }) => {
  const chevronStyle = classNames('relative top-0.5 mx-1');
  return (
    <div className='flex flex-row'>
      <HomeBreadCrumbsIcon className={classNames('w-5 h-5')} />
      <ChevronRightIcon className={chevronStyle} />
      <Link
        to={Route.CAMPAIGN_MANAGEMENT}
        className='cursor-pointer text-center font-[Manrope] text-sm font-medium text-gray-500 hover:underline'
      >
        Campaigns
      </Link>
      <ChevronRightIcon className={chevronStyle} />
      <span className='text-[#0B0A0F] font-semibold text-sm '>
        {!readOnly ? (isNew ? 'Create Campaign' : 'Edit Campaign') : 'View Campaign'}
      </span>
    </div>
  );
};

export default CreateCampaignBreadcrumbs;
